import { Breadcrumb } from "react-bootstrap";
import { Link } from "react-router-dom";
import { RouterPaths } from "../../../app/appConstants";
import { generatePath, matchPath, Route, Switch, useLocation, useParams } from "react-router";
import React, { useMemo } from "react";
import { PARTNER_API_DOCS_METHODS } from "./partnerApiDocsConstants";
import PartnerApiDocsCreateLead from "./PartnerApiDocsCreateLead/PartnerApiDocsCreateLead";
import PartnerApiDocsInfo from "./PartnerApiDocsInfo/PartnerApiDocsInfo";
import PartnerApiDocsLink from "./PartnerApiDocsLink";
import PartnerApiDocsGetStatistics from "./PartnerApiDocsGetStatistics/PartnerApiDocsGetStatistics";
import { useLangContext } from "../../../providers/LangProvider/LangProviderContext.js";

const formRoutePath = (method) => generatePath(RouterPaths.partnerApiDocs, {method});

function PartnerApiDocs(props) {
    const {getLangPath} = useLangContext();
    const {method} = useParams();
    const location = useLocation();

    const isRootApiDocsActive = useMemo(() =>
                    !!matchPath(location.pathname, {path: generatePath(RouterPaths.partnerApiDocs), exact: true}),
            [location]);

    return <>
        <Breadcrumb>
            <Breadcrumb.Item
                    active={isRootApiDocsActive}
                    linkAs={Link}
                    linkProps={{to: generatePath(RouterPaths.partnerApiDocs)}}
            >
                {getLangPath('partner.menu.api_docs.title')}
            </Breadcrumb.Item>
            {!!method && <Breadcrumb.Item active linkAs={Link}>
                {getLangPath(`partner.api_docs.methods.${method}.title`)}
            </Breadcrumb.Item>}
        </Breadcrumb>
        <h6 className="mt-4">{getLangPath('partner.api_docs.methods_title')}</h6>
        <div className="d-inline-flex flex-column mb-5">
            <PartnerApiDocsLink method={PARTNER_API_DOCS_METHODS.CREATE_LEAD}/>
            <PartnerApiDocsLink method={PARTNER_API_DOCS_METHODS.GET_STATISTICS}/>
        </div>
        <Switch>
            <Route exact path={formRoutePath()} component={PartnerApiDocsInfo}/>
            <Route exact path={formRoutePath(PARTNER_API_DOCS_METHODS.CREATE_LEAD)} component={PartnerApiDocsCreateLead}/>
            <Route exact path={formRoutePath(PARTNER_API_DOCS_METHODS.GET_STATISTICS)} component={PartnerApiDocsGetStatistics}/>
        </Switch>
    </>
}

export default PartnerApiDocs;
